import {initWebComponent} from "@/helpers/web-component-helper";
import {getBySelector} from "@/helpers/element-helper";
import {downloadPrintCesium, initPrintCesium} from "@/helpers/print/cesium/print-cesium-helper";

export class BookmarkPrintCesiumComponent extends HTMLElement {
    constructor(){
        super();

        const printScales = window.printScales
        const template = document.createElement('template');
        template.innerHTML = `
<div class="card m-3 bg-lighter" style="border-radius: 10px;">
     <div class="card-header font-weight-bold p-2">
         <span class="fa fa-print navbar-icon" style="font-size:15px"></span>
         Print
         <button class="ml-1 btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu">
            <span class="fa fa-times"></span>
         </button>
     </div>
    <div class="card-body p-2">
        <div class="form-group">
           <label class="form-label">Bestandsnaam</label>
           <input type="text" value="Download" class="form-control" id="slcPrintCesiumFileName">
        </div>
        <div class="form-group">
           <label class="form-label">Positie</label>
           <select class="custom-select" id="slcPrintCesiumPosition">
               <option value="landscape">Liggend</option>  
               <option value="portrait">Staand</option>
           </select>
        </div>
         <button class="btn btn-outline-success btn-block btn-sm mt-2" id="btnPrintCesiumDownload">Download</button>
    </div>
 </div>
`
        initWebComponent(this, template)

        getBySelector('#slcPrintCesiumPosition').addEventListener('change', () => {
            initPrintCesium()
        })

        getBySelector('#btnPrintCesiumDownload').addEventListener('click', () => {
            downloadPrintCesium()
        })
    }
}
